(function () {
    const shopifyAccessToken = "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";
    const shopifyStoreUrl = "sun-bath-colombia.myshopify.com";

    async function logPaymentEvent(orderId, status, details) {
        const orderUrl = `${shopifyStoreUrl}/admin/api/2025-01/orders/${orderId}.json`;

        // Obtener la nota actual del pedido
        let existingNote = "";
        try {
            const response = await fetch(orderUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Access-Token": shopifyAccessToken
                }
            });
            const orderData = await response.json();
            existingNote = orderData.order?.note || "";
        } catch (error) {
            console.error("Error obteniendo la nota actual del pedido:", error);
        }

        // Agregar el nuevo log a la nota del pedido
        const newLog = `🛑 ${new Date().toISOString()} - ${status}: ${JSON.stringify(details)}`;
        const updatedNote = existingNote ? `${existingNote}\n${newLog}` : newLog;

        // Guardar la nueva nota en el pedido
        const payload = {
            order: {
                id: orderId,
                note: updatedNote
            }
        };

        try {
            const response = await fetch(orderUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-Shopify-Access-Token": shopifyAccessToken
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error("Error guardando en la Nota del Pedido");

            console.log("Log de pago guardado en la Nota del Pedido", await response.json());
        } catch (error) {
            console.error("Error al guardar el log:", error);
        }
    }

    function monitorCheckout() {
        const observer = new MutationObserver(() => {
            const paymentButton = document.querySelector("button[type='submit']");

            if (paymentButton) {
                paymentButton.addEventListener("click", async function () {
                    const orderId = document.querySelector("[name='checkout[order_id]']")?.value;
                    if (orderId) {
                        await logPaymentEvent(orderId, "Intento de pago", { message: "Usuario hizo clic en pagar" });
                    }
                });
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (window.location.pathname.includes("/checkouts/")) {
        monitorCheckout();

        window.addEventListener("load", async () => {
            const orderId = document.querySelector("[name='checkout[order_id]']")?.value;
            if (orderId) {
                await logPaymentEvent(orderId, "Checkout abierto", { message: "El usuario está en la página de pago" });

                setTimeout(async () => {
                    const errorElement = document.querySelector(".errors"); // Ajusta el selector según tu tema
                    if (errorElement) {
                        await logPaymentEvent(orderId, "Error de pago", { message: errorElement.innerText });
                    }
                }, 5000);
            }
        });
    }
})();